import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StandardManagementService {
  static async getStdTemplateList() {
    RecordOperation({
      type: 'query',
    })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Common/get-std-template`))
    return Callback(err, res)
  }
  static async exportTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Common/export-std-template?${qs.stringify(payload)}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  static async getList(payload) {
    RecordOperation({
      type: 'query',
    })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdStandard?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async addList(payload) {
    RecordOperation({
      type: 'create',
    })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdStandard', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({
      type: 'update',
    })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdStandard', {
        method: 'patch',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async delete(payload) {
    RecordOperation({
      type: 'delete',
    })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdStandard', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    RecordOperation({
      type: 'detail',
    })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdStandard?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({
      type: 'export',
    })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdStandard/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  static async upGradeStandard(payload) {
    RecordOperation({
      type: 'update',
    })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdStandard/copy_stdstandard', payload)
    )
    return Callback(err, res)
  }
  static async getEntityTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTemplate/get-standar-class-attributes', payload)
    )
    return Callback(err, res)
  }
  static async saveEntity(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/data/CollectTemplate', payload))
    return Callback(err, res)
  }
  static async geEntitytList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTemplate/get-template-list', payload)
    )
    return Callback(err, res)
  }
  static async changeTemplateStatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/data/CollectTemplate/template-valid?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getTemplateData(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/data/CollectTemplate/${payload.id}`))
    return Callback(err, res)
  }
  static async updateTemplateData(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/data/CollectTemplate/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  static async getEntityTreeData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/data/CollectTemplate/get-subject-tree?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 临时数据删除
  static async deleteTempData(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/data/CollectTempData/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async insertCollectData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTemplate/insert_collect_data', payload)
    )
    return Callback(err, res)
  }
  static async getTemplateApprove(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/data/CollectTemplate/template-approve?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async dataBatchSubmit(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/DataBatch/submit', payload))
    return Callback(err, res)
  }
  // 数据实体名称列表
  static async getEnityNameList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTemplate/get-enity-name-list', payload)
    )
    return Callback(err, res)
  }
  // 按关键字获取数据实体名称列表
  static async getEnityListByKeyword(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取数据字典数据项
  static async getDataItem(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ReferenceDataItem?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 临时数据暂存
  static async collectTempData(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/data/CollectTempData', payload))
    return Callback(err, res)
  }
  // 临时数据查询
  static async getTempData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTempData/get-temp-data', payload)
    )
    return Callback(err, res)
  }
  // 多字段公用数据保存
  static async saveAttributeMapping(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/data/CollectTemplate/save_attribute_mapping', payload)
    )
    return Callback(err, res)
  }
  // 多字段公用数据查询
  static async getAttributeMapping(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/data/CollectTemplate/get_attribute_mapping?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取数据总览信息
  static async getDataOverview(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CollectMetricsMonitoring/get-data-overview/${payload}`)
    )
    return Callback(err, res)
  }
  // 数据源离线统计
  static async getDailyOfflineData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectMetricsMonitoring/get-daily-offline-data-statistics/${payload}`
      )
    )
    return Callback(err, res)
  }
  // 监控的测点离线统计
  static async getMonotoringPointData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectMetricsMonitoring/get-monitoring-pointoffline-statistics/${payload}`
      )
    )
    return Callback(err, res)
  }
  // 数据源接入的数据量统计
  static async getDatasourceVolumeData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/CollectMetricsMonitoring/get-datasource-datavolume-statistics/${payload.standardId}`,
        payload.datasourceId
      )
    )
    return Callback(err, res)
  }
  // 数据源离线排行 TOP10
  static async getDatasourceStatisticsData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectMetricsMonitoring/get-datasource-offline-statistics-ranking/${payload}`
      )
    )
    return Callback(err, res)
  }
  // 监控的测点离线排行 TOP10
  static async getMonitorPointStatisticsData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectMetricsMonitoring/get-monitoring-point-offline-statistics-ranking/${payload}`
      )
    )
    return Callback(err, res)
  }
  // 服务器资源使用情况
  static async getResourceUsageData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectMetricsMonitoring/get-resource-usage-statistics/${payload}`
      )
    )
    return Callback(err, res)
  }
  // 数据源/实体列表
  static async getCollectDataSourceData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CollectDataSourceConfig${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
